<template>
  <div class="gly-box">
	<div class="gly-box-container">
		<div class="gly-box-top">
			<span>{{$t('all.guanliyuan')}}</span>
			<img src="../../assets/image/tanchuang_x_b@2x.png" alt="关闭" @click="handleClose" />
		</div>
		<div class="gly-box-list">
			<div class="gly-box-list-item" v-for="(item,index) in list" :key="index">
				<div class="gly-box-list-item-left">
					<img :src="item.headPortrait" alt="" />
					<div class="gly-box-list-item-left-content">
						<span class="gly-box-list-item-left-content-span">{{item.nickName}}</span>
						<span class="gly-box-list-item-left-content-span1">ID：{{item.recodeCode}}</span>
					</div>
				</div>
				<img class="gly-box-list-item-img" src="../../assets/image/x_22_1@2x.png" alt="" @click="delAdmin(item.userId)" />
			</div>
			<kong v-if="isKong"/>
		</div>
	</div>
  </div>
</template>

<script>
import kong from "../kong/kong.vue";
import { getChatRoomAdminUserList,delAdmin } from "@/api/zhibo";
export default {
  components: {
    kong
  },
  data() {
    return {
	  list:[],
	  isKong:false,
	  isKjdyModel:false,
	  content:''
    };
  },
  mounted() {
	this.getChatRoomAdminUserList()
  },
  methods: {
	//管理员列表
	async getChatRoomAdminUserList(){
		const res = await getChatRoomAdminUserList({liveId:this.$route.query.liveId,page:1,size:5000})
		this.list = res.rows
		if(res.total > 0){
			this.isKong = false
		}else{
			this.isKong = true
		}
	},
	//关闭
	handleClose(){
		this.$emit('close_gly')
	},
	//删除管理员
	async delAdmin(id){
		const params = {
			toUserId:id,
			liveId:this.$route.query.liveId
		}
		const res = await delAdmin(params)
		this.getChatRoomAdminUserList()
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./guanliyuan.css";
</style>


// WEBPACK FOOTER //
// guanliyuan.vue?21855702